import { render } from "./userRegistry.vue?vue&type=template&id=d29233d4&scoped=true"
import script from "./userRegistry.vue?vue&type=script&lang=js"
export * from "./userRegistry.vue?vue&type=script&lang=js"

import "./userRegistry.vue?vue&type=style&index=0&id=d29233d4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d29233d4"]])

export default __exports__